"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var TableRow_1 = __importDefault(require("../TableRow/TableRow"));
var TableHeader_style_1 = __importDefault(require("./TableHeader.style"));
var TableHeader = function (_a) {
    var sticky = _a.sticky, columnGap = _a.columnGap, className = _a.className, cells = _a.cells, compact = _a.compact, alternatingColors = _a.alternatingColors;
    var classes = (0, TableHeader_style_1.default)();
    return ((0, jsx_runtime_1.jsx)("thead", __assign({ className: classes.thead }, { children: (0, jsx_runtime_1.jsx)(TableRow_1.default, { className: (0, classnames_1.default)(classes.root, sticky && classes.sticky, className), cells: cells, isHeadingRow: true, columnGap: columnGap, compact: compact, alternatingColors: alternatingColors }) })));
};
exports.default = TableHeader;
